/**
 * dialog - programmatic modals, entry point.
 *
 *   const ok = await g.confirm('Delete 3 users?', { danger: true }); // boolean
 *   await g.alert('Saved!');
 *   const name = await g.prompt('New name', { required: true });    // string | null
 *   const ok = await g.codePrompt('Type the emailed code.', { confirm, resend }); // true | null
 *   const v = await g.dialog({ title, body, buttons: [...] });      // generic
 *
 * The lib builds the Bootstrap modal, shows it and removes it on close - no
 * authored markup. Promises resolve AFTER the modal is fully hidden, so
 * dialogs chain safely (confirm -> alert). The confirm/OK button carries
 * key-hint="Enter" (listed in the ? panel; Enter activates it).
 *
 * Depends on genus (g.esc, g.translate, g.fieldError) + bootstrap.
 * Full reference: docs/libs/dialog.md.
 */
import { dialog, confirm, alert, prompt, codePrompt } from './dialog.js';

// Bump on every meaningful change to the library.
const VERSION = '0.4.0';

dialog.version = () => VERSION;

if (window.g) {
	window.g.dialog = dialog;
	window.g.confirm = confirm;
	window.g.alert = alert;
	window.g.prompt = prompt;
	window.g.codePrompt = codePrompt;
	window.g.registerLib('dialog');
} else {
	window.dialog = dialog; // genus not loaded (shouldn't happen in the template)
}
